(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oaluxx-luxury-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const syncPreviews = () => {
    document.querySelectorAll('[data-story-preview]').forEach((video) => {
      video.muted = true;
      if (motion.matches || document.hidden) video.pause();
      else video.play().catch(() => {});
    });
  };
  syncPreviews();
  motion.addEventListener('change', syncPreviews);
  document.addEventListener('visibilitychange', syncPreviews);
  document.addEventListener('shopify:section:load', syncPreviews);
})();
if (!window.oaluxxStoriesBound) {
  window.oaluxxStoriesBound = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-story-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.storyOpen);
      if (!dialog) return;
      dialog.showModal();
      const video = dialog.querySelector('video');
      video.play().catch(() => {});
      if (!dialog.dataset.bound) {
        dialog.addEventListener('close', () => { video.pause(); trigger.focus(); });
        dialog.addEventListener('click', (e) => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
        dialog.dataset.bound = 'true';
      }
    }
    const close = event.target.closest('.ol-story-close');
    if (close) close.closest('dialog').close();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
